/* eslint-disable */
require('infinite-scroll');
/* Pinned section
   ––––––––––––––––––––––––––––––––––––––––––––––––––––
   Website : fueko.net
   Author  : fueko
  –––––––––––––––––––––––––––––––––––––––––––––––––––– */

const e=document.querySelector(".pinned-section"),t=document.querySelector(".pinned-pages"),n=document.querySelector(".pinned-posts"),o=document.querySelector(".pinned-pages .item-1"),s=document.querySelector(".pinned-pages .item-2"),r=document.querySelector(".pinned-pages .item-3"),i=document.querySelector(".pinned-pages .item-4"),m=document.querySelector(".pinned-posts .item-1"),d=document.querySelector(".pinned-posts .item-2"),c=document.querySelector(".pinned-posts .item-3"),l=document.querySelector(".pinned-posts .item-4");e&&(m||o||e.remove()),o&&(t.style.flexBasis="25%",n&&(n.style.flexBasis="75%"),l&&l.remove()),s&&(t.style.flexBasis="50%",n&&(n.style.flexBasis="50%"),c&&c.remove(),l&&l.remove()),r&&(t.style.flexBasis="75%",n&&(n.style.flexBasis="25%"),d&&d.remove(),c&&c.remove(),l&&l.remove()),i&&(t.style.flexBasis="100%",n&&n.remove());



/* Custom settings for Infinite Scroll */
const nextPage = document.getElementById('next-page'),
      loadmoreButton = document.querySelector('.load-more');

if (nextPage) {
   var infScroll = new InfiniteScroll('.loop-section', {
      path: '#next-page',
      append: '.loop-wrap',
      history: false,
      button: loadmoreButton,
      hideNav: '#next-page'
   });

   infScroll.on('load', onPageLoad);

   function onPageLoad() {
      if (infScroll.loadCount == 1) {
         infScroll.options.loadOnScroll = false;
         loadmoreButton.style.display = 'inline-block';
         infScroll.off(onPageLoad);
      }
   }

   if (numberPaged < 3) {
      loadmoreButton.parentNode.removeChild(loadmoreButton);
   }

   infScroll.on('append', function(response, path, items) {
      for (var i = 0; i < items.length; i++) {
         reloadSrcsetImgs(items[i]);
      }
   });

   function reloadSrcsetImgs(item) {
      var imgs = item.querySelectorAll('img[srcset]');
      for (var i = 0; i < imgs.length; i++) {
         var img = imgs[i];
         img.outerHTML = img.outerHTML;
      }
   }
}



// WEBPACK FOOTER //
// ./scripts/libraries/renge/index.js